import React from "react";
import { Box, Typography, useTheme } from "@mui/material";
import Title from "../../typography/Title";
import { decodeColor } from "../../../helpers/color";

const ShadowBox = ({
    children,
    padding = 4,
    mt = 0,
    mb = 0,
    title = null,
    titleVariant = "h1",
    width = undefined,
    height = undefined,
    backgroundColor = undefined,
    alignItems = undefined,
    display = undefined,
    gap = undefined,
    borderRadius = "8px",
    boxShadow = 4,
}) => {
    const theme = useTheme();
    const bgcolor = decodeColor(backgroundColor, theme);
    return (
        <Box
            sx={{
                display: display,
                width: width,
                height: height,
                marginTop: theme.spacing(mt),
                marginBottom: theme.spacing(mb),
                boxShadow: theme.shadows[boxShadow],
                borderRadius: borderRadius,
                backgroundColor: bgcolor,
                alignItems: alignItems,
                gap: Boolean(gap) ? theme.spacing(gap) : undefined,
            }}
        >
            {
                Boolean(title) && Boolean(titleVariant) ? <Title pt={4} label={title} variant={titleVariant} pl={10} /> : null
            }
            <Box width="100%" p={padding}>
                {
                    Boolean(title) && !Boolean(titleVariant) ? <Typography fontWeight="bold" mb={theme.spacing(2)}>{title}</Typography> : null
                }
                {children}
            </Box>
        </Box>
    );
}

export default ShadowBox;
